<template lang="pug">
.speaker-tag
  cl-img(
    v-if="speaker._embedded.profile_image"
    :cl-id="speaker._embedded.profile_image.cl_id"
    :transform="{ width: size, height: size, crop: 'thumb' }"
    :style="`width:${size/2}px; height:${size/2}px;`"
  )
  span {{ speaker.full_name }}
</template>

<script>
export default {
  name: 'speaker-tag',
  computed: {
    speaker() {
      return this.value;
    },
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    size: {
      type: Number,
      default: 60,
    },
  },
};
</script>

<style lang="scss">
.speaker-tag {
  display: flex;
  align-items: center;
  img {
    border-radius: 60px;
    margin-right: 0.5rem;
  }
}
</style>
